const NumberIcon = ({ title, Icon, number, className = "", titleClassName = "", numberClassName = "" }) => {
    return (
        <div
            className={
                "group flex cursor-pointer items-center rounded-[20px] bg-white p-5 hover:bg-nt-blue " +
                className
            }
        >
            <div className="ml-2.5 mr-5 flex h-[60px] w-[60px] shrink-0 items-center justify-center rounded-full bg-[#eee] p-[5px] text-nt-blue group-hover:bg-nt-red group-hover:text-white">
                <Icon size={"24px"} />
            </div>
            <div className="flex-1 text-nt-blue group-hover:text-white">
                <h3 className={"text-lg font-light xl:text-xl " + titleClassName}>{title}</h3>
                <h2 className={"text-right font-semibold " + numberClassName}>{number}</h2>
            </div>
        </div>
    );
};

export { NumberIcon };
